import { render, staticRenderFns } from "./DonateCardBlackbaudIframe.vue?vue&type=template&id=37369f80&"
import script from "./DonateCardBlackbaudIframe.vue?vue&type=script&lang=js&"
export * from "./DonateCardBlackbaudIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports